/**
 * The API wraps every payload in `{ error, response, result }`, and `makeRequest`
 * hands that envelope back as-is. A caller that treats the envelope as the list
 * itself gets a TypeError from `.map`, and if it catches that by "defaulting" to
 * an empty selection, it has just thrown away the real one -- which is how
 * selecting one waste type used to wipe an organization's whole basket.
 */

function payloadOf(response: unknown): unknown {
  return response && typeof response === "object" && "result" in response
    ? (response as { result: unknown }).result
    : response;
}

/** The list inside the envelope; an empty list for anything that is not one. */
export function unwrapList<T>(response: unknown): T[] {
  const rows = payloadOf(response);
  return Array.isArray(rows) ? (rows as T[]) : [];
}

/** The object inside the envelope; null for anything that is not one. */
export function unwrapOne<T>(response: unknown): T | null {
  const row = payloadOf(response);
  return row && typeof row === "object" && !Array.isArray(row) ? (row as T) : null;
}
